module.exports = __webpack_public_path__ + "static/media/manipura.87ee0d2d.png";